import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("scroll", this.handleScroll.bind(this));
    // Initial check
    this.handleScroll();
  }

  handleScroll() {
    const { scrollTop, scrollLeft } = this.element;

    // Add shadow when scrolling vertically
    this.element.classList.toggle("scrolled-vertically", scrollTop > 0);

    // Handle horizontal scrolling - apply this first
    const isScrollingHorizontally = scrollLeft > 0;

    // Apply the class after modifying DOM
    this.element.classList.toggle(
      "scrolled-horizontally",
      isScrollingHorizontally
    );
  }
}
